module.exports = __webpack_public_path__ + "static/img/mould6-1.80004c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould6-1.png
// module id = rW8+
// module chunks = 3